export function getProvider() {
  throw new Error('@publishweaver/ai-providers is not yet implemented');
}
export function getAllProviders() { return []; }
export function fetchOllamaModels() { return Promise.resolve([]); }
